export enum EOpening
{
    /// <summary>
    /// Auto
    /// </summary>
    A = 1,
    /// <summary>
    /// Left
    /// </summary>
    L = 2,
    /// <summary>
    /// Right
    /// </summary>
    R = 3,
    /// <summary>
    /// Top
    /// </summary>
    T = 4,
    /// <summary>
    /// Bottom
    /// </summary>
    B = 5,
}